import React from "react";

function runcateText(text, max = 20, mode = "end") {
  if (!text || text.length <= max) return text;
  if (max <= 3) return text.slice(0, max);

  if (mode === "start") {
    // …end kept
    return "…" + text.slice(text.length - (max - 1));
  }
  if (mode === "middle") {
    const keep = max - 3;
    const left = Math.ceil(keep / 2);
    const right = Math.floor(keep / 2);
    return text.slice(0, left) + "…" + text.slice(text.length - right);
  }
  // "end" (default)
  return text.slice(0, max - 1) + "…";
}

export function TruncatedText({ text, max = 20, mode = "end", className = "" }) {
  const shown = runcateText(text, max, mode);
  return (
    <span className={className} title={text}>
      {shown}
    </span>
  );
}

export function TruncatedTextHTML({ text, max = 20, mode = "end" }) {
  const shown = runcateText(text, max, mode);
  return { __html: shown };
}
